import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export const getLineItemHistory = (lineItemExternalIds: number[] | string[], requestId) => {
  const url = ApiUrl('/line_item_history');

  return Call(
    'post',
    url,
    {
      bid_request_id: requestId,
      line_item_ids: lineItemExternalIds
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        line_item_history: 'line_item_history',
      },
    }
  );
};
